import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-847ae366"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-sm-12 col-xl-6" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "card-header" }, "Dépenses", -1 /* HOISTED */))
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "col-sm-12 mt-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "financieres.depenses.coutsDirects",
  class: "me-2 col-form-label col-sm-8"
}, "Coûts directs", -1 /* HOISTED */))
const _hoisted_8 = { class: "form-group mnt d-inline-block" }
const _hoisted_9 = { class: "col-sm-12 mt-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "financieres.depenses.honorairesProfessionnels",
  class: "me-2 col-form-label col-sm-8"
}, "Honoraires professionnels", -1 /* HOISTED */))
const _hoisted_11 = { class: "form-group mnt d-inline-block" }
const _hoisted_12 = { class: "col-sm-12 mt-2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "financieres.depenses.fraisFinancement",
  class: "me-2 col-form-label col-sm-8"
}, "Frais de financement", -1 /* HOISTED */))
const _hoisted_14 = { class: "form-group mnt d-inline-block" }
const _hoisted_15 = { class: "col-sm-12 mt-2" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "financieres.depenses.imprevusContingence",
  class: "me-2 col-form-label col-sm-8"
}, "Imprévus et contingence", -1 /* HOISTED */))
const _hoisted_17 = { class: "form-group mnt d-inline-block" }
const _hoisted_18 = { class: "col-sm-12 mt-2" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "financieres.depenses.taxesNettes",
  class: "me-2 col-form-label col-sm-8"
}, "Taxes nettes", -1 /* HOISTED */))
const _hoisted_20 = { class: "form-group mnt d-inline-block" }
const _hoisted_21 = { class: "col-sm-12 mt-2" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "financieres.depenses.fraisAutres",
  class: "me-2 col-form-label col-sm-8"
}, "Frais autres", -1 /* HOISTED */))
const _hoisted_23 = { class: "form-group mnt d-inline-block" }
const _hoisted_24 = { class: "col-sm-12 mt-2" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "financieres.depenses.total",
  class: "me-2 col-form-label col-sm-8 fw-bold"
}, "Dépenses totales", -1 /* HOISTED */))
const _hoisted_26 = { class: "form-group mnt d-inline-block total" }
const _hoisted_27 = { class: "col-sm-12 col-xl-6" }
const _hoisted_28 = { class: "card" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "card-header" }, "Crédits et détermination de l'emprunt", -1 /* HOISTED */))
const _hoisted_30 = { class: "card-body" }
const _hoisted_31 = { class: "col-sm-12 mt-2" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "financieres.credits.subventionsConfirmees",
  class: "me-2 col-form-label col-sm-8"
}, "Subventions confirmées et payées comptant", -1 /* HOISTED */))
const _hoisted_33 = { class: "form-group mnt d-inline-block" }
const _hoisted_34 = { class: "col-sm-12 mt-2" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "financieres.credits.contributionsFonds",
  class: "me-2 col-form-label col-sm-8"
}, "Contributions du fonds général, d'autres fonds ou des réserves financières", -1 /* HOISTED */))
const _hoisted_36 = { class: "form-group mnt d-inline-block" }
const _hoisted_37 = { class: "col-sm-12 mt-2" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "financieres.credits.soldeDisponible",
  class: "me-2 col-form-label col-sm-8"
}, "Solde disponible de règlement d'emprunt fermé", -1 /* HOISTED */))
const _hoisted_39 = { class: "form-group mnt d-inline-block" }
const _hoisted_40 = { class: "col-sm-12 mt-2" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "financieres.credits.autresSources",
  class: "me-2 col-form-label col-sm-8"
}, "Autres sources", -1 /* HOISTED */))
const _hoisted_42 = { class: "form-group mnt d-inline-block" }
const _hoisted_43 = { class: "col-sm-12 mt-2" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "financieres.credits.total",
  class: "me-2 col-form-label col-sm-8 fw-bold"
}, "Total des crédits disponibles", -1 /* HOISTED */))
const _hoisted_45 = { class: "form-group mnt d-inline-block total" }
const _hoisted_46 = { class: "col-sm-12" }
const _hoisted_47 = { class: "card" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "card-header" }, "Emprunt prévu au règlement à approuver (Dépenses totales - Crédits disponibles)", -1 /* HOISTED */))
const _hoisted_49 = { class: "card-body" }
const _hoisted_50 = { class: "col-sm-12 mt-2" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "financieres.empruntPrevu",
  class: "me-2 col-form-label col-sm-8 fw-bold"
}, "Emprunt prévu au règlement à approuver (Dépenses totales - Crédits disponibles)", -1 /* HOISTED */))
const _hoisted_52 = { class: "form-group mnt d-inline-block total" }
const _hoisted_53 = { class: "col-sm-12 mt-2" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "financieres.montantsApresApprobation.subventions",
  class: "me-2 col-form-label col-sm-8"
}, "Subventions à recevoir ou payables sur plusieurs années", -1 /* HOISTED */))
const _hoisted_55 = { class: "form-group mnt d-inline-block" }
const _hoisted_56 = { class: "col-sm-12 mt-2" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "financieres.montantsApresApprobation.autresSources",
  class: "me-2 col-form-label col-sm-8"
}, "Autres sources", -1 /* HOISTED */))
const _hoisted_58 = { class: "form-group mnt d-inline-block" }
const _hoisted_59 = { class: "col-sm-12 mt-2" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "empty" }, null, -1 /* HOISTED */))
const _hoisted_61 = { class: "form-group mnt d-inline-block total" }
const _hoisted_62 = { class: "col-sm-12 mt-2" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "financieres.empruntACharge",
  class: "me-2 col-form-label col-sm-8 fw-bold"
}, "Emprunt à la charge de l'organisme municipal", -1 /* HOISTED */))
const _hoisted_64 = { class: "form-group mnt d-inline-block total" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputMontant = _resolveComponent("InputMontant")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    title: "Informations financières",
    "forced-opened": _ctx.forcedOpened
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_InputMontant, {
                    parent: _ctx.reglement.financieres.depenses,
                    champ: "coutsDirects",
                    id: "financieres.depenses.coutsDirects",
                    readonly: _ctx.readonly,
                    "on-input": _ctx.calculerTotalDepenses
                  }, null, 8 /* PROPS */, ["parent", "readonly", "on-input"])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_InputMontant, {
                    parent: _ctx.reglement.financieres.depenses,
                    champ: "honorairesProfessionnels",
                    id: "financieres.depenses.honorairesProfessionnels",
                    readonly: _ctx.readonly,
                    "on-input": _ctx.calculerTotalDepenses
                  }, null, 8 /* PROPS */, ["parent", "readonly", "on-input"])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_InputMontant, {
                    parent: _ctx.reglement.financieres.depenses,
                    champ: "fraisFinancement",
                    id: "financieres.depenses.fraisFinancement",
                    readonly: _ctx.readonly,
                    "on-input": _ctx.calculerTotalDepenses
                  }, null, 8 /* PROPS */, ["parent", "readonly", "on-input"])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_InputMontant, {
                    parent: _ctx.reglement.financieres.depenses,
                    champ: "imprevusContingence",
                    id: "financieres.depenses.imprevusContingence",
                    readonly: _ctx.readonly,
                    "on-input": _ctx.calculerTotalDepenses
                  }, null, 8 /* PROPS */, ["parent", "readonly", "on-input"])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_InputMontant, {
                    parent: _ctx.reglement.financieres.depenses,
                    champ: "taxesNettes",
                    id: "financieres.depenses.taxesNettes",
                    readonly: _ctx.readonly,
                    "on-input": _ctx.calculerTotalDepenses
                  }, null, 8 /* PROPS */, ["parent", "readonly", "on-input"])
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_InputMontant, {
                    parent: _ctx.reglement.financieres.depenses,
                    champ: "fraisAutres",
                    id: "financieres.depenses.fraisAutres",
                    readonly: _ctx.readonly,
                    "on-input": _ctx.calculerTotalDepenses
                  }, null, 8 /* PROPS */, ["parent", "readonly", "on-input"])
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_InputMontant, {
                    parent: _ctx.reglement.financieres.depenses,
                    champ: "total",
                    id: "financieres.depenses.total",
                    readonly: ""
                  }, null, 8 /* PROPS */, ["parent"])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(_component_InputMontant, {
                    parent: _ctx.reglement.financieres.credits,
                    champ: "subventionsConfirmees",
                    id: "financieres.credits.subventionsConfirmees",
                    readonly: _ctx.readonly,
                    "on-input": _ctx.calculerTotalCredits
                  }, null, 8 /* PROPS */, ["parent", "readonly", "on-input"])
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _createElementVNode("div", _hoisted_36, [
                  _createVNode(_component_InputMontant, {
                    parent: _ctx.reglement.financieres.credits,
                    champ: "contributionsFonds",
                    id: "financieres.credits.contributionsFonds",
                    readonly: _ctx.readonly,
                    "on-input": _ctx.calculerTotalCredits
                  }, null, 8 /* PROPS */, ["parent", "readonly", "on-input"])
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _createElementVNode("div", _hoisted_39, [
                  _createVNode(_component_InputMontant, {
                    parent: _ctx.reglement.financieres.credits,
                    champ: "soldeDisponible",
                    id: "financieres.credits.soldeDisponible",
                    readonly: _ctx.readonly,
                    "on-input": _ctx.calculerTotalCredits
                  }, null, 8 /* PROPS */, ["parent", "readonly", "on-input"])
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _createElementVNode("div", _hoisted_42, [
                  _createVNode(_component_InputMontant, {
                    parent: _ctx.reglement.financieres.credits,
                    champ: "autresSources",
                    id: "financieres.credits.autresSources",
                    readonly: _ctx.readonly,
                    "on-input": _ctx.calculerTotalCredits
                  }, null, 8 /* PROPS */, ["parent", "readonly", "on-input"])
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _createElementVNode("div", _hoisted_45, [
                  _createVNode(_component_InputMontant, {
                    parent: _ctx.reglement.financieres.credits,
                    champ: "total",
                    id: "financieres.credits.total",
                    readonly: ""
                  }, null, 8 /* PROPS */, ["parent"])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _hoisted_48,
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _hoisted_51,
                _createElementVNode("div", _hoisted_52, [
                  _createVNode(_component_InputMontant, {
                    parent: _ctx.reglement.financieres,
                    champ: "empruntPrevu",
                    id: "financieres.empruntPrevu",
                    readonly: ""
                  }, null, 8 /* PROPS */, ["parent"])
                ])
              ]),
              _createElementVNode("div", _hoisted_53, [
                _hoisted_54,
                _createElementVNode("div", _hoisted_55, [
                  _createVNode(_component_InputMontant, {
                    parent: _ctx.reglement.financieres.montantsApresApprobation,
                    champ: "subventions",
                    id: "financieres.montantsApresApprobation.subventions",
                    readonly: _ctx.readonly,
                    "on-input": _ctx.calculerTotalMontantsApresApprobation
                  }, null, 8 /* PROPS */, ["parent", "readonly", "on-input"])
                ])
              ]),
              _createElementVNode("div", _hoisted_56, [
                _hoisted_57,
                _createElementVNode("div", _hoisted_58, [
                  _createVNode(_component_InputMontant, {
                    parent: _ctx.reglement.financieres.montantsApresApprobation,
                    champ: "autresSources",
                    id: "financieres.montantsApresApprobation.autresSources",
                    readonly: _ctx.readonly,
                    "on-input": _ctx.calculerTotalMontantsApresApprobation
                  }, null, 8 /* PROPS */, ["parent", "readonly", "on-input"])
                ])
              ]),
              _createElementVNode("div", _hoisted_59, [
                _hoisted_60,
                _createElementVNode("div", _hoisted_61, [
                  _createVNode(_component_InputMontant, {
                    parent: _ctx.reglement.financieres.montantsApresApprobation,
                    champ: "total",
                    id: "financieres.montantsApresApprobation",
                    readonly: ""
                  }, null, 8 /* PROPS */, ["parent"])
                ])
              ]),
              _createElementVNode("div", _hoisted_62, [
                _hoisted_63,
                _createElementVNode("div", _hoisted_64, [
                  _createVNode(_component_InputMontant, {
                    parent: _ctx.reglement.financieres,
                    champ: "empruntACharge",
                    id: "financieres.empruntACharge",
                    readonly: ""
                  }, null, 8 /* PROPS */, ["parent"])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["forced-opened"]))
}